document.addEventListener('DOMContentLoaded', function() {
    function initVideoControls() {
      const videoContainers = document.querySelectorAll('.cs-video-container');
      
      videoContainers.forEach(container => {
        const playButton = container.querySelector('.cs-play-button');
        const videoCover = container.querySelector('.cs-video-cover');
        const iframe = container.querySelector('.cs-video-iframe');
        const nativeVideo = container.querySelector('.cs-video-native');
        
        // Hide play button and cover for iframe videos (YouTube/Vimeo)
        // They have their own player controls
        if (iframe) {
          if (playButton) {
            playButton.style.display = 'none';
          }
          if (videoCover) {
            videoCover.style.display = 'none';
          }
          return; // Skip initialization for iframe videos
        }
        
        // Only initialize controls for native videos
        if (!playButton || !videoCover || !nativeVideo) return;
        
        let isPlaying = false;
        let player = null;
        
        function togglePlay() {
          if (isPlaying) {
            pauseVideo();
          } else {
            playVideo();
          }
        }
        
        function playVideo() {
          if (iframe) {
            const videoType = iframe.getAttribute('data-video-type');
            
            if (videoType === 'youtube') {
              if (!player) {
                iframe.src = iframe.src.replace('autoplay=0', 'autoplay=1');
              } else {
                player.playVideo();
              }
            } else if (videoType === 'vimeo') {
              iframe.src = iframe.src.replace('autoplay=0', 'autoplay=1');
            }
          } else if (nativeVideo) {
            nativeVideo.play();
          }
          
          isPlaying = true;
          playButton.classList.add('playing');
          
          videoCover.style.opacity = '0';
          setTimeout(() => {
            videoCover.style.display = 'none';
          }, 300);
        }
        
        function pauseVideo() {
          if (iframe) {
            const videoType = iframe.getAttribute('data-video-type');
            
            if (videoType === 'youtube') {
              if (player) {
                player.pauseVideo();
              }
            } else if (videoType === 'vimeo') {
              iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
            }
          } else if (nativeVideo) {
            nativeVideo.pause();
          }
          
          isPlaying = false;
          playButton.classList.remove('playing');
        }
        
        playButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          togglePlay();
        });
        
        if (iframe) {
          const videoType = iframe.getAttribute('data-video-type');
          
          if (videoType === 'youtube') {
            if (typeof YT !== 'undefined' && YT.Player) {
              player = new YT.Player(iframe, {
                events: {
                  'onStateChange': function(event) {
                    if (event.data === YT.PlayerState.PLAYING) {
                      isPlaying = true;
                      playButton.classList.add('playing');
                    } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                      isPlaying = false;
                      playButton.classList.remove('playing');
                    }
                  }
                }
              });
            }
          }
        } else if (nativeVideo) {
          nativeVideo.addEventListener('play', function() {
            isPlaying = true;
            playButton.classList.add('playing');
          });
          
          nativeVideo.addEventListener('pause', function() {
            isPlaying = false;
            playButton.classList.remove('playing');
          });
          
          nativeVideo.addEventListener('ended', function() {
            isPlaying = false;
            playButton.classList.remove('playing');
          });
        }
      });
    }
    
    initVideoControls();
  });
  